/* eslint-ignore */
// @ts-nocheck
import React from 'react';
import { Alert, TextAlert, IconAlert } from './style';

export default function AlertInline({ text }) {
  return (
    <Alert>
      <IconAlert className="mdi mdi-alert" />
      <TextAlert>{text}</TextAlert>
    </Alert>
  );
}
